

export default {
  documentStates  : [ 'meta.status' ],
  actionCategories: [ 'actionDetails.actionCategories' ],
  aichis          : [ 'actionDetails.aichiTargets' ],
  sdgs            : [ 'actionDetails.sdgs' ],
  orgTypes        : [ 'actor.types' ],
  govTypes        : [ 'actor.types' ],
  subjects        : [ 'actionDetails.thematicAreas' ],
  countries       : [ 'actionDetails.operationalAreas', 'actor.country.identifier', 'contacts.country.identifier' ],
  regions         : [ 'actionDetails.operationalAreas' ]
}